import React from "react";


import {
  Card,
  CardBody,
  Content,
  Grid,
  GridItem,
  List,
  ListItem,
  PageSection,
  Stack,
  StackItem
} from "@patternfly/react-core";


import {
  ExternalLinkAltIcon
} from "@patternfly/react-icons";


import {
  mLegitymacjaDocuments
} from "./data/mLegitymacjaDocuments";


const MLegitymacjaPage = () => {
  return (
    <PageSection isWidthLimited>
      <Stack hasGutter>
        <StackItem>
          <Grid>
            <GridItem span={12} md={8} mdOffset={2}>
              <Content style={{ textAlign: "center" }}>
                <h1>mLegitymacja</h1>

                <p>
                  Informacje i dokumenty dotyczące mLegitymacji szkolnej.
                </p>
              </Content>
            </GridItem>
          </Grid>
        </StackItem>

        <StackItem>
          <Grid>
            <GridItem
              span={12}
              md={10}
              mdOffset={1}
              lg={8}
              lgOffset={2}
            >
            <Card isGlass>
                <CardBody>
                <Grid hasGutter>
                    <GridItem span={12} md={4}>
                    <Content>
                        <List isPlain>
                        {mLegitymacjaDocuments.map((document) => (
                            <ListItem key={document.id}>
                            <a
                                href={document.href}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                {document.title}{" "}
                                <ExternalLinkAltIcon />
                            </a>
                            </ListItem>
                        ))}
                        </List>
                    </Content>
                    </GridItem>

                    <GridItem
                    span={12}
                    md={8}
                    style={{
                        display: "flex"
                    }}
                    >
                    <img
                        src="/assets/images/school-site/mlegitymacja/mlegitymacja.jpg"
                        alt="mLegitymacja szkolna"
                        style={{
                        display: "block",
                        width: "100%",
                        height: "100%",
                        objectFit: "cover"
                        }}
                    />
                    </GridItem>
                </Grid>
                </CardBody>
            </Card>
            </GridItem>
          </Grid>
        </StackItem>
      </Stack>
    </PageSection>
  );
};


export default MLegitymacjaPage;